module.exports = __webpack_public_path__ + "img/drone_03_H.fb37dee2.jpg";